"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConnectKitProvider, getDefaultConfig } from "connectkit";
import { http, WagmiProvider, createConfig } from "wagmi";
import { CHAIN } from "./constants";

const COMMON_PARAMS = {
  walletConnectProjectId: process.env.NEXT_PUBLIC_PAYMENT_PROJECT_ID || "defaultProjectId",
  appName: "KOLZ - AI Agents for Automatic Social Posting",
  appDescription:
    "KOLZ builds AI Agents that post for you in your exact tone and voice. Fully automated content across X and LinkedIn, powered by real-time data.",
  appUrl: "https://kolz.chat",
  appIcon: "https://kolz.chat/favicon.ico",
};

const config = createConfig(
  getDefaultConfig({
    chains: [CHAIN],
    transports: {
      [CHAIN.id]: http(process.env.NEXT_PUBLIC_RPC_URL),
    },
    ...COMMON_PARAMS,
  }),
);

const queryClient = new QueryClient();

export const Web3Provider = ({ children }: { children: React.ReactNode }) => {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <ConnectKitProvider>{children}</ConnectKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
};
